import React, { createContext, ReactNode, useContext, useEffect, useState } from 'react';
import { SparklesIcon } from 'lucide-react';
import { Modal } from './Modal';
import { TalkToUsOverlay } from './TalkToUsOverlay';
interface ModalContextType {
  isSignupModalOpen: boolean;
  openSignupModal: () => void;
  closeSignupModal: () => void;
  isTalkToUsOpen: boolean;
  openTalkToUs: () => void;
  closeTalkToUs: () => void;
}
const ModalContext = createContext<ModalContextType | undefined>(undefined);
export const useModal = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
};
interface ModalProviderProps {
  children: ReactNode;
}
export const ModalProvider: React.FC<ModalProviderProps> = ({
  children
}) => {
  const [isSignupModalOpen, setIsSignupModalOpen] = useState(false);
  const [isTalkToUsOpen, setIsTalkToUsOpen] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const openSignupModal = () => {
    setFormSubmitted(false);
    setIsSignupModalOpen(true);
  };
  const closeSignupModal = () => setIsSignupModalOpen(false);
  const openTalkToUs = () => setIsTalkToUsOpen(true);
  const closeTalkToUs = () => setIsTalkToUsOpen(false);
  const formUrl = 'https://cdn.forms-content-1.sg-form.com/433ba15d-81c9-11f0-8078-3eee6f6a2b83';
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data?.formSubmitted) setFormSubmitted(true);
    };
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);
  return <ModalContext.Provider value={{
    isSignupModalOpen,
    openSignupModal,
    closeSignupModal,
    isTalkToUsOpen,
    openTalkToUs,
    closeTalkToUs
  }} data-id="element-326" data-mp="14re3w1xwdci8">
      {children}

      <Modal isOpen={isSignupModalOpen} onClose={closeSignupModal} data-id="element-327" data-mp="vtasvzkjfy4o">
        <div className="w-full" data-id="element-328" data-mp="10s5ch3qbxqpu">
          {formSubmitted ? <div className="py-8 text-center" data-id="element-329" data-mp="10tyh6dhdu0v7">
              <div className="mb-4 inline-flex h-16 w-16 items-center justify-center rounded-full bg-primary-50 text-primary-600" data-id="element-330" data-mp="32hb5bnlaagmx">
                <SparklesIcon className="h-8 w-8" data-id="element-331" data-mp="2xorq6m6y7dg0" />
              </div>
              <h3 className="mb-2 font-serif text-2xl text-cyan-950" data-id="element-332" data-mp="2ss9s2564idcn">
                Thanks, you&apos;re on the list
              </h3>
              <p className="text-base leading-relaxed text-gray-600" data-id="element-333" data-mp="2orhex0u4rob3">
                We&apos;ll send occasional updates from Nisa.
              </p>
            </div> : <iframe src={formUrl} className="h-[660px] w-full border-0" title="Nisa updates form" onLoad={event => {
          try {
            event.currentTarget.contentWindow?.addEventListener('submit', () => {
              window.parent.postMessage({
                formSubmitted: true
              }, '*');
            });
          } catch {
            // The hosted form may prevent same-origin event access.
          }
        }} data-id="element-334" data-mp="3ggkngst1vktj" />}
        </div>
      </Modal>

      <TalkToUsOverlay isOpen={isTalkToUsOpen} onClose={closeTalkToUs} data-id="element-335" data-mp="biwxdbtvrvw3" />
    </ModalContext.Provider>;
};